module.exports = __webpack_public_path__ + "img/main02.44f0eb6b.jpg";